import { EventResponse } from '@goldcast/api/backend';

import { ListPageType, State } from './types';

import { PardotList } from '@/studio/eventIntegration/store/types';

const getters = {
  getEvents(state: State): Array<EventResponse> {
    return Object.values(state.events);
  },
  getCurrentEvent(state: State): EventResponse | undefined {
    if (state.events[state.currentEventId]) {
      return state.events[state.currentEventId];
    }
  },
  getRegistrationForm(_, getters): string {
    const currentEvent = getters.getCurrentEvent;
    return (currentEvent && currentEvent.registration_form) || '';
  },
  marketoConnectedProgramID(_, getters): string {
    const currentEvent = getters.getCurrentEvent;
    return (currentEvent && currentEvent.marketo_campaign_id) || '';
  },
  salesforceConnectedCampaignID(_, getters): string {
    const currentEvent = getters.getCurrentEvent;
    return (currentEvent && currentEvent.salesforce_campaign_id) || '';
  },
  wistiaConnectedProjectID(_, getters): string {
    const currentEvent = getters.getCurrentEvent;
    return (currentEvent && currentEvent.wistia_project_id) || '';
  },
  pardotImportList(_, getters): PardotList[] {
    const currentEvent = getters.getCurrentEvent;
    return (currentEvent && currentEvent.pardot_list.filter(item => item.activity_type === 'SYNC_PARDOT')) || [];
  },
  pardotExportList(_, getters): PardotList[] {
    const currentEvent = getters.getCurrentEvent;
    return (currentEvent && currentEvent.pardot_list.filter(item => item.activity_type !== 'SYNC_PARDOT')) || [];
  },
  getRegistrationFormInfo(_, getters): string {
    const currentEvent = getters.getCurrentEvent;
    return currentEvent?.registration_form_data || {};
  },
  getLastOpenedPage(state: State): ListPageType {
    return state.lastOpenedPage;
  }
};

export default getters;
